import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit/react';

import { userApi } from '~/domain/user/api';
import { auth } from '../auth';

export const authListenerMiddleware = createListenerMiddleware();

authListenerMiddleware.startListening({
    matcher: isAnyOf(auth.actions.setAuthToken),
    effect: async (action: PayloadAction<any>, listenerApi) => {
        const token = action.payload;

        if (token) {
            try {
                const user = (await listenerApi.dispatch(userApi.endpoints.currentUser.initiate())).data;
                userApi.util.invalidateTags(['CurrentUser']);
                listenerApi.dispatch(auth.actions.setUser(user || null));
            } catch (error) {
                console.error('authListenerMiddleware: ', error);
            }
        }
    },
});
